"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _entriesReverse = _interopRequireDefault(require("./entriesReverse"));

var _default = (0, _unmutable.default)({
  name: 'findLastIndex',
  immutable: 'findLastIndex',
  all: function all(predicate) {
    return function (value) {
      var iterator = (0, _entriesReverse.default)()(value);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = iterator[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
              key = _step$value[0],
              _value = _step$value[1];

          if (predicate(_value, key, _value)) {
            return key;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return -1;
    };
  }
});

exports.default = _default;